/**
 * Table utilities for generating table structure from field configurations
 */
import { formatFieldValue } from "@/core/fields";
import { getNestedValue } from "@/lib/object-utils";
function fieldToHeadCell(field, columnIndex, rowspan = 1, colspan = 1) {
    return {
        label: field.label,
        align: field.align,
        width: field.width,
        className: field.className,
        color: field.color,
        colspan,
        rowspan,
        columnIndex,
        field,
    };
}
/**
 * Generates a table head structure from field configurations
 */
export const generateTableHead = (fields) => {
    const hasGroupedHeaders = fields.some((field) => field.type === "group");
    if (!hasGroupedHeaders) {
        return [fields.map((field, index) => fieldToHeadCell(field, index, 1, 1))];
    }
    const firstRow = [];
    const secondRow = [];
    fields.forEach((field, fieldIndex) => {
        var _a, _b, _c;
        if (field.type === "group") {
            firstRow.push(fieldToHeadCell(field, fieldIndex, 1, ((_a = field.children) === null || _a === void 0 ? void 0 : _a.length) || 1));
            const visibleChildren = (_c = (_b = field.children) === null || _b === void 0 ? void 0 : _b.filter((subField) => !subField.hidden)) !== null && _c !== void 0 ? _c : [];
            firstRow[firstRow.length - 1].colspan = visibleChildren.length || 1;
            visibleChildren.forEach((subField) => {
                secondRow.push(fieldToHeadCell(Object.assign({ color: field.color }, subField), fieldIndex, 1, 1));
            });
        }
        else {
            firstRow.push(fieldToHeadCell(field, fieldIndex, 2, 1));
        }
    });
    return [firstRow, secondRow];
};
/**
 * Generates table body data from data rows and field configurations
 */
export const generateTableBody = (data, fields) => {
    return data.map((row) => {
        const parsedRow = [];
        fields.forEach((field) => {
            if (field.type === "group" && field.children) {
                field.children.filter((subField) => !subField.hidden).forEach((subField) => {
                    const value = getNestedValue(row, subField.key);
                    parsedRow.push(formatFieldValue(value, subField));
                });
            }
            else {
                const value = getNestedValue(row, field.key);
                parsedRow.push(formatFieldValue(value, field));
            }
        });
        return parsedRow;
    });
};
